// 学员流程控制

export default {
  // 是否可撤销
  isRevoke() {
    // 已撤销 && 已失效 && 未摇中
    return row => row.sign_up_status !== window.ENUM.signUpFlowStatus.REVOKE
      && row.sign_up_status !== window.ENUM.signUpFlowStatus.INVALID
      && row.sign_up_status !== window.ENUM.signUpFlowStatus.ROCKING_NUMBER_FAILED;
  },
  // 是否可激活
  isActive() {
    // 待激活 || 已撤销 || 已失效
    return row => (row.sign_up_status === window.ENUM.signUpFlowStatus.TO_ACTIVATE
      || row.sign_up_status === window.ENUM.signUpFlowStatus.REVOKE
      || row.sign_up_status === window.ENUM.signUpFlowStatus.INVALID) && Number(row.class_phase) !== 3;
  },
  // 已缴费才可转班
  isTransfer() {
    return row => row.sign_up_status === window.ENUM.signUpFlowStatus.PAID && Number(row.class_phase) !== 3;
  },
  // 可缴费才能打折
  isDiscount() {
    return row => row.sign_up_status === window.ENUM.signUpFlowStatus.TO_PAY && Number(row.class_phase) !== 3;
  },
  // 退款（已支付 && !已结课）
  isRefund() {
    return row => row.sign_up_status === window.ENUM.signUpFlowStatus.PAID && Number(row.class_phase) !== 3;
  }
};
